var exports = {
  "J": "Label__oGhEg6",
  "Z": "AggregateLabels__ysAiLP",
};

module.exports = exports;
